import type { TSerializedWidget } from 'src/entities/workspace/types';
import { AlertsManagerWidgetEntity } from 'src/pages/dashboard/features/alerts-manager-widget/AlertsManagerWidget.entity';
import { parseAlertsManagerWidgetInternalState } from 'src/pages/dashboard/features/alerts-manager-widget/parseAlertsManagerWidget';

export function mapAlertsManagerWidget(widget: TSerializedWidget, index: number): AlertsManagerWidgetEntity {
  const internalState = parseAlertsManagerWidgetInternalState(widget.internalState);

  return new AlertsManagerWidgetEntity(
    {
      wellId: internalState.wellId,
      stateParams: internalState.stateParams,
      type: 'alerts-manager-widget',
      isEditMode: internalState.isEditMode ?? false,
    },
    {
      uuid: widget.uuid,
      isPinned: !!widget.isPinned,
      zIndex: index + 1,
      isFullscreen: widget.isFullscreen ?? false,
      position: {
        x: widget?.position?.x ?? 0,
        y: widget?.position?.y ?? 0,
      },
      size: {
        w: widget.size?.w ?? 59,
        h: widget.size?.h ?? 316,
      },
      groupId: widget.groupId,
      isGroupsDefaultOpened: false,
    },
  );
}
